module.exports = __webpack_public_path__ + "img/mark2.3822d3b2.png";